__turbopack_context__.v({
  "buzzLoader": "UserBuzz-module-scss-module__Gnb6xa__buzzLoader",
  "buzzText": "UserBuzz-module-scss-module__Gnb6xa__buzzText",
  "userBuzz": "UserBuzz-module-scss-module__Gnb6xa__userBuzz",
  "withGradient": "UserBuzz-module-scss-module__Gnb6xa__withGradient",
});
